export function normalizeProjectTitle(value: string): string {
    const title = String(value || '').trim();
    if (!title) throw new Error('Project title is required.');
    return title;
}

export function projectSettingsPath(slug: string): string {
    const normalized = String(slug || '').trim();
    if (!normalized) throw new Error('Project slug is required.');
    return `/clients/projects/${encodeURIComponent(normalized)}?edit=settings`;
}
